module.exports = __webpack_public_path__ + "static/media/close.815a1bc4.svg";